import { render, staticRenderFns } from "./PartnerLayout.vue?vue&type=template&id=10c9143c&scoped=true"
import script from "./PartnerLayout.vue?vue&type=script&lang=js"
export * from "./PartnerLayout.vue?vue&type=script&lang=js"
import style0 from "./PartnerLayout.vue?vue&type=style&index=0&id=10c9143c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10c9143c",
  null
  
)

export default component.exports